
import Component from '../../../assets/scripts/modules/component';
import required from '../../../vendor/scripts/fabrique/modules/required';

export class BackgroundImage extends Component {

  constructor() {
    super(...arguments);
  }

  init() {
    this.observer = null;
    this.style = this.element.parentNode.querySelector('style');

    if (this.element.getAttribute('data-lazyload') === null || !this.style) {
      return;
    }

    this.element.removeAttribute('data-lazyload');

    // Set observers on next paint (otherwise it'll cause a forced layout reflow)
    window.requestAnimationFrame(() => this.attachObserver());

    // Allows for forcing the load, for example, when in a swiper and intersectionobserver is unreliable
    this.element.forceLoad = () => {
      this.loadImage();
      this.disconnectObserver();
      this.destroy();
      this.element.forceLoad = null;
    };

  }

  destroy() {

    this.style = null;
    this.observer = null;

  }

  attachObserver() {

    if (this.observer) {
      this.disconnectObserver();
    }

    // Set the rootMargin so we start intersecting halfway outside the viewport
    this.observer = new window.IntersectionObserver(this.onIntersect.bind(this), { rootMargin: `${window.innerHeight / 2}px` });
    this.observer.observe(this.element);

  }

  disconnectObserver() {

    if (!this.observer) {
      return;
    }

    this.observer.unobserve(this.element);
    this.observer.disconnect();
    this.observer = null;

  }

  onIntersect(entries = required()) {

    for (const entry of entries) {
      if (entry.intersectionRatio) {
        this.loadImage();
        this.disconnectObserver();
        this.destroy();

        break;
      }
    }

  }

  loadImage() {
    if (this.element.classList.contains('is-loading') || this.element.classList.contains('has-loaded')) {
      return;
    }
    this.element.classList.add('is-loading');
    this.parseStyle();

    // Possible leak? requestAnimationFrame doesn't put it in the queue
    window.setTimeout(() => {
      this.element.classList.remove('is-loading');
      this.element.classList.add('has-loaded');
    }, 0);

  }

  replaceRule(rule) {

    if (rule.style) {
      const data = rule.style.fontFamily;

      if (data) {
        rule.style.backgroundImage = `url(${data})`;
        rule.style.fontFamily = '';
      }
    }

    if (rule.cssRules) {
      for (const subrule of rule.cssRules) {
        this.replaceRule(subrule);
      }
    }

  }

  parseStyle() {
    // IE 11 doesn't like it if we regex.replace text of the style node itself. So, we're going to travel the long way 'round.
    const stylesheet = [...document.styleSheets].filter(sheet => sheet.ownerNode === this.style)[0];

    for (const rule of stylesheet.cssRules) {
      this.replaceRule(rule);
    }

  }

}

for (const element of document.querySelectorAll('.background-image')) {
  element.instance = new BackgroundImage('background-image', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/background-image/background-image-generic.js